const Offer = {
  productFamiliesWithFares: ({ journeys = [] }) => {
    const allProductFamilies = journeys.flatMap((journey) => journey.fares?.flatMap((fare) => fare.productFamily) || []);

    const uniqueProductFamilies = allProductFamilies.reduce((uniquePF, productFamily) => {
      if (productFamily?.familyGroup && !uniquePF[productFamily.familyGroup]) {
        uniquePF[productFamily.familyGroup] = productFamily;
      }

      return uniquePF;
    }, {});

    return Object.values(uniqueProductFamilies).sort((a, b) => a.familyGroup.localeCompare(b.familyGroup));
  }
};

export default Offer;
